// name of fields in CreationWizard root component state
export default {
	selectedAppId: { type: Number },
	selectedCredentialsConfiguration: { type: Object },
	selectedPlacementId: { type: Number },
	selectedPlacementVersionId: { type: Number },
	selectedContextId: { type: Number },
	selectedInstallableId: { type: String },
	selectedProjectId: { type: Number },
	selectedFeatureTypeId: { type: String },
	selectedPlacementParamsMap: { type: Object },
	selectedPlacementParamsMapLabels: { type: Object },
	selectedElementType: { type: String },
	extensionMode: { type: Boolean },
	embeddedMode: { type: Boolean },
};
